<template>
<div>
<v-app-bar color="primary" dark>
  <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
<!--     <v-avatar :tile="true"
    @click="$router.push('/').catch(err => {})">
    <img :src="require('../../public/img/icons/logo.svg')">
  </v-avatar> -->
  <v-toolbar-title @click="$router.push('/').catch(err => {})">DreamHolidayTZ</v-toolbar-title>
  <v-btn icon @click="$router.go(-1)">
    <v-icon>mdi-arrow-left</v-icon>
  </v-btn>
  <v-spacer></v-spacer>
  <v-btn icon v-if="$route.name=='Home'" @click="getMessagingToken">
  <v-icon>mdi-bell-outline</v-icon>
  </v-btn>
</v-app-bar>
<v-navigation-drawer
  v-model="drawer"
  absolute
  temporary>
  <v-list nav dense>
    <v-list-item-group
    v-model="group"
    active-class="blue--text text--accent-4">
    <v-list-item
      v-for="item in items"
      :key="item.title"
      :to="item.to"
      link
      >
      <v-list-item-icon>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    </v-list-item-group>
  </v-list>
</v-navigation-drawer>
</div>
</template>

<script>
import firebase from '../configFirebase.js'
import axios from 'axios';

const { messaging } = firebase;

export default {
  name: 'NavigationDrawer',
  data () {
    return {
      drawer: false,
      group: true,
      items: [
        { title: 'Zanzibar', icon: 'mdi-beach', to: '/zanzibar' },
        { title: 'Safari', icon: 'mdi-elephant', to: '/safari' },
        { title: 'Testimonials', icon: 'mdi-view-dashboard', to: '/testimonials' },
        { title: 'About', icon: 'mdi-help-box', to: '/about' },
        { title: 'Contact', icon: 'mdi-send', to: '/contact' },
      ],
    }
  },
  mounted() {
    this.listenTokenRefresh();
    console.log(this.$route.name)
  },
  methods: {
    getMessagingToken () {
      messaging.getToken().then(async (token) => {
        if (token) {
            const currentMessageToken = window.localStorage.getItem('messagingToken')
            console.log('token will be updated', currentMessageToken != token)
            if(currentMessageToken != token){
              await this.saveToken(token)
            }
          } else {
            console.log('No Instance ID token available. Request permission to generate one.');
            this.notificationsPermisionRequest();
          }
      }).catch(function(err) {
        console.log('An error occurred while retrieving token. ', err);
      });
    },
  notificationsPermisionRequest () {
    messaging.requestPermission()
    .then(() => {
      this.getMessagingToken();
    })
    .catch((err) => {
      console.log('Unable to get permission to notify.', err);
    }); 
  },
  listenTokenRefresh() {
    if (!messaging) return
    const currentMessageToken = window.localStorage.getItem('messagingToken')
    console.log('currentMessageToken', currentMessageToken);
    if(!currentMessageToken){
      messaging.onTokenRefresh(function() {
        messaging.getToken().then(function(token) {
          this.saveToken(token);
        }).catch(function(err) {
          console.log('Unable to retrieve refreshed token ', err);
        });
      });
    }
  },
  saveToken(token) {
    console.log('tokens', token)
    axios.post(`https://us-central1-pwa-travel.cloudfunctions.net/GeneralSubscription`,{ token })
    .then(response => {
      window.localStorage.setItem('messagingToken',token)
      console.log(response)
    }).catch((err) => {
      console.log(err)
    })
  },
}
}
</script>

